import { useRef } from "react";

export function useHolo() {
  const innerRef = useRef(null);

  const setVars = (x, y, rx, ry) => {
    const el = innerRef.current;
    if (!el) return;
    el.style.setProperty("--mx", `${x}%`);
    el.style.setProperty("--my", `${y}%`);
    el.style.setProperty("--rx", `${rx}deg`);
    el.style.setProperty("--ry", `${ry}deg`);
  };

  const activate = () => innerRef.current?.classList.add("holo-active");

  const deactivate = () => {
    innerRef.current?.classList.remove("holo-active");
    setVars(50, 50, 0, 0);
  };

  const onPointerMove = (e) => {
    const el = innerRef.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const x = Math.max(-30, Math.min(130, ((e.clientX - r.left) / r.width) * 100));
    const y = Math.max(-30, Math.min(130, ((e.clientY - r.top) / r.height) * 100));
    setVars(x, y, ((y / 100 - 0.5) * -16).toFixed(2), ((x / 100 - 0.5) * 20).toFixed(2));
  };

  return { innerRef, activate, deactivate, onPointerMove };
}
